import { useLocation } from "react-router-dom";
import useAppConfigStore from "../store/useAppConfigStore";
export const useIsRefreshedDashboardFlag = () => useAppConfigStore((state) => Boolean(state.appConfig?.release_1_1?.eflowLiveDashboardRefresh));
// The refreshed chrome is scoped to the Live and AI Insights tabs of a project-details route;
// every other route and tab keeps the existing layout while the flag is rolling out.
export const useIsRefreshedLiveDashboard = () => {
    const { pathname, search } = useLocation();
    const isRefreshedDashboardEnabled = useIsRefreshedDashboardFlag();
    const activeTab = new URLSearchParams(search).get("tab");
    return (isRefreshedDashboardEnabled &&
        pathname.startsWith("/project-details/") &&
        (!activeTab || activeTab === "Live" || activeTab === "AIInsights"));
};
export const useIsConnectorPowerControlFlag = () => useAppConfigStore((state) => Boolean(state.appConfig?.release_1_1?.showConnectorPowerControl));
